// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Qq-z","slideIn":"Rq-z"};